import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // 店舗IDの初期値と現在の値を比較し、変更有無をhidden fieldに反映する
  static targets = ["select", "changed"]
  static values = { initialOfficeId: String }

  update() {
    this.changedTarget.value = String(this.selectTarget.value !== this.initialOfficeIdValue)
  }
}
